import { useState, useEffect, useRef } from 'react';

export const useNotes = ({
  promotionData,
  setPromotionData,
  loadedPromotionData,
  mode,
  fetchHeadlineData,
  historicPromotionData,
}) => {
  const [includeNotes, setIncludeNotes] = useState(!!historicPromotionData?.notes);
  const [notes, setNotes] = useState(historicPromotionData?.notes || '');
  const valuesLoadedInitially = useRef(mode !== 'Edit');
  const [discountOfferNotAvailable, setDiscountOfferNotAvailable] = useState(false);
  const [financeOfferNotAvailable, setFinanceOfferNotAvailable] = useState(false);

  const handleNoteInclude = (event) => {
    setIncludeNotes(event.target.checked);
    if (!event.target.checked) {
      setPromotionData({
        ...promotionData,
        notes: '',
      });
      setNotes('');
    } else {
      setPromotionData({
        ...promotionData,
        notes: '',
      });
    }
  };

  const handleNotes = (value) => {
    setNotes(value);
  };

  const handleNotesChange = () => {
    setPromotionData({
      ...promotionData,
      notes,
    });

    // added to set preview only when no headlines is selected in create mode
    if (
      mode === 'Create' &&
      promotionData?.discount_offer == null &&
      promotionData?.finance_offer == null
    ) {
      fetchHeadlineData({ ...promotionData, notes });
    }
  };

  const disableConditionCheckFun = () => {
    if (mode === 'Edit') {
      // to check disable condition for discount
      if (
        promotionData?.discount_offer == null ||
        Object.keys(promotionData?.discount_offer || {})?.length === 0
      ) {
        setDiscountOfferNotAvailable(true);
      } else {
        setDiscountOfferNotAvailable(false);
      }

      // to check disable condition for finance
      if (promotionData?.finance_offer?.length === 0) {
        setFinanceOfferNotAvailable(true);
      } else {
        setFinanceOfferNotAvailable(false);
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      // added this checks due to performance related issue on first time edit promotion publish error issue
      if (includeNotes) {
        handleNotesChange();
      }
    }, 1500); // 1500ms delay

    // Cleanup function to clear the timeout if the value changes before the delay is over
    return () => clearTimeout(timer);
  }, [notes]);

  useEffect(() => {
    if (promotionData && loadedPromotionData) {
      const { notes } = promotionData;

      if (notes && !!notes && !valuesLoadedInitially.current) {
        setIncludeNotes(true);
        setNotes(notes);
      }
      valuesLoadedInitially.current = true;
      disableConditionCheckFun();
    }

    if (promotionData && !!promotionData?.notes) {
      setNotes(promotionData?.notes || '');
      setIncludeNotes(true);
    }
  }, [promotionData, loadedPromotionData, historicPromotionData]);

  // Determine what tooltip text to display based on conditions
  const getTooltipText = () => {
    if (discountOfferNotAvailable && financeOfferNotAvailable) {
      return 'Please select headline to edit notes';
    }
    if (!includeNotes) {
      return 'For adding notes please select include';
    }
    return '';
  };

  const isDisabled = discountOfferNotAvailable && financeOfferNotAvailable;

  return {
    includeNotes,
    notes,
    isDisabled,
    handleNoteInclude,
    handleNotes,
    getTooltipText,
  };
};
